const defaultJDISettings = {
    autofix: true,
    canvas_width: 12,
    canvas_height: 12,
    ortho: true,

    grid_snap_global: true,
    grid_snap_size: .25,
    grid_snap_show: true,

    line_snap_global: true,
    line_snap_endpoints: true,
    line_snap_midpoints: true,
    line_snap_intersections: true,
    line_snap_aligned: true,

    polygon_facets: 20,
    polygon_rotation: 0
  }

export default defaultJDISettings;


// WEBPACK FOOTER //
// ./src/pattern_utilities/defaultJDISettings.js